import { Routes, Route, Navigate } from "react-router-dom"
import {
  HomePage,
  LoginPage,
  LoginEpicorPage,
  PendingEpicorPage,
  ViewEpicorPRPage,
  ViewEpicorPOPage,
  ViewEpicorIRPage,
  CreateCapexPage,
  HistoryCapexPage,
  ApplicationListsPage,
  CreateZoomRequestPage,
  CreateTicketPage,
  CreateTicketDetailPage,
  CreateTicketCheckinPage,
  HistoryTicketDetailPage,
  HistoryTicketPage,
  TSHistoryPage,
  TSCreatePage,
  TSViewPage,
  ViewTSPrintPage,
  ViewTSPrintRangePage,
  WFPendingListPage,
  VerificationChangeNumberPage,
  ViewBillingTelkomselPage,
  ViewTsApprovePage,
  CompletedUserDataPage,
  ApprovedPage,
  VerificationPage,
  DASTRHistoryPage,
  CreateDASTRPage,
  ViewDASTRPage,
  CreateServiceRequestPage,
  SRHistoryPage,
  ViewSRPage,
  PrintSRPage,
  PATransactionHistoryPage,
  PACreatePage,
  PAViewPage,
  PAEditPage,
  UnderConstructionPage,
  CreateTravelAuthorityPage,
  EditTravelAuthorityPage,
  TAHistoryPage,
  ViewTAPrintPage,
  ViewTAPage,
  AssetSystemPage,
  CreateHiasPage,
  CreatePPERequestPage,
  PPEHistoryPage,
  ViewPPERequestPage,
  ViewVWPApprovePage,
  ViewWPApprovePage,
  CreateWorkingPermitPage,
  HistoryWPPage,
  ViewWPPrintPage,
  ViewWPPage,
  RequestDeliveryFuelAdjustmentPage,
  ResetPasswordOperatorPage,
  ViewRequestDeliveryFuelPage,
  FuelRequestAdjustmentPage,
  CreateRequestDeliveryFuelPage,
  CreateOperatorPage,
  ViewRequestFuelPage,
  CreateRequestFuelPage,
  WorkPermitDashboardPage,
  ProjectMonitoringPage,
  CPMFuelDashboardPage,
  FuelMenuPage,
  FarmsActivityPage,
  DriverMenuPage,
  BiddingHistoryPage,
  CreateBiddingPage,
  ViewBiddingPage,
  BiddingPrintPage,
  NotFoundPage,
  SuccessPage,
  SapMasterProductsPage,
  SapSuppliersPage,
  SapMasterEmployeesPage,
  SapMasterProductsAddPage,
  SapMasterProductsDetailPage,
  SapMasterProductsEditPage,
  SapSuppliersAddPage,
  SapSuppliersEditPage,
  SapSupplierDetailPage,
  SapAssetsPage,
  SapAssetsAddPage,
  SapAssetDetailPage,
  SapAssetsEditPage,
  SapReservationsPage,
  SapReservationsAddPage,
  SapReservationDetailPage,
  HeTimesheetsPage,
  HeTimesheetsAddPage,
  HeTimesheetsEditPage,
  HeTimesheetDetailPage,
  SimperDetailsPage,
  SapBiddingHistoryPage,
  SapCreateBidding,
  SapViewBidding,
  SapPage,
  WellnessAddPage,
} from "@/containers"
import GlobalLayout from "@/layouts/GlobalLayout"
import SapAuthGuard from "@/features/shared/components/SapAuthGuard"

function Router() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />

      <Route element={<GlobalLayout />}>
        <Route path="/home" element={<HomePage />} />

        {/* Epicor  */}
        <Route path="/epicor/loginEpicor" element={<LoginEpicorPage />} />
        <Route path="/epicor/pending" element={<PendingEpicorPage />} />
        <Route path="/epicor/pr/:id" element={<ViewEpicorPRPage />} />
        <Route path="/epicor/po/:id" element={<ViewEpicorPOPage />} />
        <Route path="/epicor/ir/:id" element={<ViewEpicorIRPage />} />
        {/* Capex */}
        <Route path="capex/create" element={<CreateCapexPage />} />
        <Route path="capex/history" element={<HistoryCapexPage />} />
        <Route path="/cr/view/:id" element={<CreateCapexPage />} />
        <Route path="/wf/cr/view/:id" element={<CreateCapexPage />} />

        {/* Project Monitoring */}
        <Route path="project-monitoring" element={<ProjectMonitoringPage />} />

        {/* Working Permit Dashboard */}
        <Route path="wp-dashboard" element={<WorkPermitDashboardPage />} />

        {/* FARMS Activity Dashboard */}
        <Route path="farms-activity-dashboard" element={<FarmsActivityPage />} />

        {/* CPM Fuel Dashboard */}
        <Route path="fuel-dashboard" element={<CPMFuelDashboardPage />} />

        {/* Zoom Request */}
        <Route path="zoom" element={<CreateZoomRequestPage />} />

        {/* Booking Driver */}
        <Route path="driver" element={<DriverMenuPage />} />
        <Route path="/wf/bd/view/:id" element={<DriverMenuPage />} />
        <Route path="/bd/view/:id" element={<DriverMenuPage />} />

        {/* Help center */}

        <Route path="help">
          <Route index element={<Navigate to="create-ticket" replace />} />

          <Route path="history-ticket" element={<HistoryTicketPage />} />
          <Route path="history-ticket/detail/:id" element={<HistoryTicketDetailPage />} />
          <Route path="detail/:id" element={<HistoryTicketDetailPage />} />

          <Route path="create-ticket" element={<CreateTicketPage />} />
          <Route path="create-ticket-detail" element={<CreateTicketDetailPage />} />
          <Route path="create-ticket-checkin" element={<CreateTicketCheckinPage />} />
        </Route>

        <Route path="saphelp">
          <Route index element={<Navigate to="create-ticket" replace />} />

          <Route path="history-ticket" element={<HistoryTicketPage />} />
          <Route path="history-ticket/detail/:id" element={<HistoryTicketDetailPage />} />
          <Route path="detail/:id" element={<HistoryTicketDetailPage />} />

          <Route path="create-ticket" element={<CreateTicketPage />} />
          <Route path="create-ticket-detail" element={<CreateTicketDetailPage />} />
          <Route path="create-ticket-checkin" element={<CreateTicketCheckinPage />} />
        </Route>

        {/* Timesheet */}
        <Route path="ts/create" element={<TSCreatePage />} />
        <Route path="ts/history" element={<TSHistoryPage />} />
        <Route path="ts/view/:id" element={<TSViewPage />} />
        <Route path="ts/print/:id" element={<ViewTSPrintPage />} />
        <Route path="ts/print-range" element={<ViewTSPrintRangePage />} />

        {/* Workflow Process */}
        <Route path="wf/pending" element={<WFPendingListPage />} />
        <Route path="wf/approved/:id" element={<ApprovedPage />} />

        {/* Approved Page */}
        <Route path="wf/ts/view/:id" element={<ViewTsApprovePage />} />
        <Route path="wf/bt/view/:id" element={<ViewBillingTelkomselPage />} />
        <Route path="wf/sr/view/:id" element={<ViewSRPage />} />
        <Route path="wf/ta/view/:id" element={<ViewTAPage />} />
        <Route path="wf/wp/view/:id" element={<ViewWPApprovePage />} />
        <Route path="wf/vwp/view/:id" element={<ViewVWPApprovePage />} />
        <Route path="wf/frs/view/:id" element={<ViewRequestFuelPage />} />
        <Route path="wf/dst/view/:recordId" element={<ViewDASTRPage />} />
        <Route path="wf/ppe/view/:id" element={<ViewPPERequestPage />} />

        <Route path="wf/fds/view/:id" element={<ViewRequestDeliveryFuelPage />} />

        {/* Verification */}
        <Route path="/verification/:id/:token" element={<VerificationPage />} />
        <Route path="/verification/change/:token" element={<VerificationChangeNumberPage />} />

        {/* Completed data User */}
        <Route path="/completed-user" element={<CompletedUserDataPage />} />

        {/* Service Request */}
        <Route path="sr/create" element={<CreateServiceRequestPage />} />
        <Route path="sr/view/:id" element={<ViewSRPage />} />
        <Route path="sr/print/:id" element={<PrintSRPage />} />
        <Route path="sr/history" element={<SRHistoryPage />} />

        {/* Performance Appraisal */}
        <Route path="pa/history" element={<PATransactionHistoryPage />} />
        <Route path="pa/create" element={<PACreatePage />} />
        <Route path="pa/view/:recordId" element={<PAViewPage />} />
        <Route path="pa/edit/:recordId" element={<PAEditPage />} />
        <Route path="wf/pa/view/:recordId" element={<PAViewPage />} />
        <Route path="wf/pa/edit/:recordId" element={<PAEditPage />} />

        {/* DASTR (Document Approval System for Tracking Requests) */}
        <Route path="dst/history" element={<DASTRHistoryPage />} />
        <Route path="dst/create" element={<CreateDASTRPage />} />
        <Route path="dst/view/:recordId" element={<ViewDASTRPage />} />

        {/* Travel Authority */}
        <Route path="ta/create" element={<CreateTravelAuthorityPage />} />
        <Route path="ta/edit/:id" element={<EditTravelAuthorityPage />} />
        <Route path="ta/view/:id" element={<ViewTAPage />} />
        <Route path="ta/history" element={<TAHistoryPage />} />
        <Route path="ta/print/:id" element={<ViewTAPrintPage />} />

        {/* PPE Request */}
        <Route path="ppe/create" element={<CreatePPERequestPage />} />
        <Route path="ppe/view/:id" element={<ViewPPERequestPage />} />
        <Route path="ppe/history" element={<PPEHistoryPage />} />

        {/* HIAS */}
        <Route path="hias/create" element={<CreateHiasPage />} />

        {/* Working Permit */}
        <Route path="wp/create" element={<CreateWorkingPermitPage />} />
        <Route path="wp/history" element={<HistoryWPPage />} />
        <Route path="wp/view/:id" element={<ViewWPPage />} />
        <Route path="wp/print/:id" element={<ViewWPPrintPage />} />

        {/* Fuel MS */}
        <Route path="fms/menu" element={<FuelMenuPage />} />
        <Route path="fms/request/create" element={<CreateRequestFuelPage />} />
        <Route path="fms/request/view/:id" element={<ViewRequestFuelPage />} />
        <Route path="fms/delivery/create" element={<CreateRequestDeliveryFuelPage />} />
        <Route path="fms/request/adjustment/:id" element={<FuelRequestAdjustmentPage />} />
        <Route path="fms/delivery/adjustment/:id" element={<RequestDeliveryFuelAdjustmentPage />} />
        <Route path="fms/delivery/view/:id" element={<ViewRequestDeliveryFuelPage />} />
        <Route path="fms/operator/register" element={<CreateOperatorPage />} />
        <Route path="fms/operator/reset" element={<ResetPasswordOperatorPage />} />

        {/* Bidding  */}
        <Route path="bidding/history" element={<BiddingHistoryPage />} />
        <Route path="bidding/create" element={<CreateBiddingPage />} />
        <Route path="bidding/create/:id" element={<CreateBiddingPage />} />
        <Route path="bidding/view/print/:id" element={<BiddingPrintPage />} />
        <Route path="wf/bdng/view/:id" element={<ViewBiddingPage />} />

        {/* Asset System */}

        {/* Under Constructions */}
        <Route path="under-construction" element={<UnderConstructionPage />} />

        {/* Application List */}
        <Route path="application-list" element={<ApplicationListsPage />} />

        {/* Asset App */}
        <Route path="asset-system" element={<AssetSystemPage />} />

        {/* SAP Modules */}
        <Route element={<SapAuthGuard />}>
          <Route path="/sapprd/history" element={<SapMasterProductsPage />} />
          <Route path="/sapprd/create" element={<SapMasterProductsAddPage />} />
          <Route path="/sapprd/edit/:recordId" element={<SapMasterProductsEditPage />} />
          <Route path="/sapprd/view/:recordId" element={<SapMasterProductsDetailPage />} />
          <Route path="/wf/sapprd/view/:recordId" element={<SapMasterProductsDetailPage />} />
          <Route path="/sapspl/history" element={<SapSuppliersPage />} />
          <Route path="/sapspl/create" element={<SapSuppliersAddPage />} />
          <Route path="/sapspl/edit/:recordId" element={<SapSuppliersEditPage />} />
          <Route path="/sapspl/view/:recordId" element={<SapSupplierDetailPage />} />
          <Route path="/wf/sapspl/view/:recordId" element={<SapSupplierDetailPage />} />
          <Route path="/sapasst/history" element={<SapAssetsPage />} />
          <Route path="/sapasst/create" element={<SapAssetsAddPage />} />
          <Route path="/sapasst/edit/:recordId" element={<SapAssetsEditPage />} />
          <Route path="/sapasst/view/:recordId" element={<SapAssetDetailPage />} />
          <Route path="/wf/sapasst/view/:recordId" element={<SapAssetDetailPage />} />
          <Route path="/saprsv/history" element={<SapReservationsPage />} />
          <Route path="/saprsv/create" element={<SapReservationsAddPage />} />
          <Route path="/saprsv/view/:recordId" element={<SapReservationDetailPage />} />
          <Route path="/wf/saprsv/view/:recordId" element={<SapReservationDetailPage />} />

          {/* SAP BIDDING */}
          <Route path="sapbdng/history" element={<SapBiddingHistoryPage />} />
          <Route path="sapbdng/create" element={<SapCreateBidding />} />
          <Route path="sapbdng/view/:id" element={<SapViewBidding />} />
          <Route path="wf/sapbdng/view/:id" element={<SapViewBidding />} />
        </Route>
        <Route path="sap/master-employees" element={<SapMasterEmployeesPage />} />
        <Route path="sap" element={<SapPage />} />

        <Route path="hets/history" element={<HeTimesheetsPage />} />
        <Route path="hets/create" element={<HeTimesheetsAddPage />} />
        <Route path="hets/edit/:recordId" element={<HeTimesheetsEditPage />} />
        <Route path="hets/view/:recordId" element={<HeTimesheetDetailPage />} />
        <Route path="/wf/hets/view/:recordId" element={<HeTimesheetDetailPage />} />

        <Route path="simper/public/:simperNumber" element={<SimperDetailsPage />} />

        {/* Wellness Support Guide */}
        <Route path="wellness/add" element={<WellnessAddPage />} />

        <Route path="200" element={<SuccessPage />} />
        <Route path="*" element={<NotFoundPage />} />

        <Route path="200" element={<SuccessPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default Router
